import { ANY_ZONE, Place, Route, Zone } from "./types";

/**
 * Tabela inicial baseada na lista de preços enviada pelo WhatsApp.
 * Usada pelo botão "Carregar tabela de exemplo" quando o painel está vazio.
 */
interface SeedZone extends Zone {
  id: string;
  places: { name: string; aliases?: string[] }[];
  tiers: Route["tiers"];
}

export const SEED_ZONES: SeedZone[] = [
  {
    id: "norte_aeroporto",
    name: "Norte da Ilha + Aeroporto",
    order: 1,
    active: true,
    places: [
      { name: "Canasvieiras" },
      { name: "Jurerê", aliases: ["Jurere", "Jurerê Internacional"] },
      { name: "Praia Brava" },
      { name: "Cachoeira do Bom Jesus", aliases: ["Cachoeira"] },
      { name: "Ingleses", aliases: ["Praia dos Ingleses"] },
      { name: "Aeroporto Hercílio Luz", aliases: ["Aeroporto", "Aeroporto de Florianópolis", "FLN"] },
    ],
    tiers: [
      { minPax: 1, maxPax: 4, price: 180 },
      { minPax: 5, maxPax: 6, price: 250 },
    ],
  },
  {
    id: "leste_centro",
    name: "Leste / Centro",
    order: 2,
    active: true,
    places: [
      { name: "Barra da Lagoa" },
      { name: "Lagoa da Conceição", aliases: ["Lagoa"] },
      { name: "Centro de Florianópolis", aliases: ["Centro", "Florianópolis", "Floripa"] },
    ],
    tiers: [
      { minPax: 1, maxPax: 4, price: 120 },
      { minPax: 5, maxPax: 6, price: 180 },
    ],
  },
  {
    id: "balneario_camboriu",
    name: "Balneário Camboriú",
    order: 3,
    active: true,
    places: [{ name: "Balneário Camboriú", aliases: ["Balneario", "BC"] }],
    tiers: [
      { minPax: 1, maxPax: 4, price: 400 },
      { minPax: 5, maxPax: 6, price: 450 },
    ],
  },
  {
    id: "penha",
    name: "Penha",
    order: 4,
    active: true,
    places: [{ name: "Penha", aliases: ["Beto Carrero", "Beto Carrero World"] }],
    tiers: [
      { minPax: 1, maxPax: 4, price: 450 },
      { minPax: 5, maxPax: 6, price: 500 },
    ],
  },
  {
    id: "praia_do_rosa",
    name: "Praia do Rosa",
    order: 5,
    active: true,
    places: [{ name: "Praia do Rosa", aliases: ["Rosa", "Imbituba"] }],
    tiers: [
      { minPax: 1, maxPax: 4, price: 400 },
      { minPax: 5, maxPax: 6, price: 450 },
    ],
  },
];

const slug = (value: string) =>
  value
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_|_$/g, "");

/** Gera o objeto de `update` multi-path (caminhos relativos a `pricing/`). */
export function buildSeedUpdates(): Record<string, Zone | Place | Route> {
  const updates: Record<string, Zone | Place | Route> = {};

  SEED_ZONES.forEach((zone) => {
    updates[`zones/${zone.id}`] = {
      name: zone.name,
      order: zone.order,
      active: zone.active,
    };

    zone.places.forEach((place) => {
      updates[`places/${slug(place.name)}`] = {
        name: place.name,
        zoneId: zone.id,
        aliases: place.aliases ?? [],
        active: true,
      };
    });

    updates[`routes/any_to_${zone.id}`] = {
      originZoneId: ANY_ZONE,
      destinationZoneId: zone.id,
      bidirectional: true,
      active: true,
      tiers: zone.tiers,
    };
  });

  return updates;
}
